$(document).ready(function () {
  $(".atd-tab-collection-carousel").owlCarousel({
    loop: false,
    nav: false,
    dots: true,
    slideTransition: "linear",
    margin: 0,
    // touchDrag: false,
    responsive: {
      0: {
        items: 1,
      },
      768: {
        items: 2.25,
      },
      1200: {
        items: 4,
      },
    },
  });
});

const tabs = document.querySelectorAll(".tab-container .tab");
const collections = document.querySelectorAll(".tab-collection .collections");

tabs?.forEach((tab, index) => {
  if (index === 0) tab.classList.add("active-tab");
});

collections?.forEach((collection, index) => {
  if (index === 0) collection.classList.add("active-collection");
});

tabs.forEach((tab) => {
  tab.addEventListener("click", (e) => {
    tabs.forEach((innerTab) => {
      innerTab.classList.remove("active-tab");
    });
    collections?.forEach((collection) => {
      collection.classList.remove("active-collection");
      if (tab.id === collection.id)
        collection.classList.add("active-collection");
    });
    tab.classList.add("active-tab");
  });
});
